import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import {
  TextInput,
  NumberInput,
  SimpleGrid,
  Button,
  Center,
} from "@mantine/core";
import { scrollToElementWithOffset } from "../../../../utils/scrollToElementWithOffset";



const QuoteLinkForm = ({ onSubmit, isLoading }) => {

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      name: "",
      email: "",
      phone: "",
    },
  });

  const onSubmitForm = (data) => {
    onSubmit(data);
    reset();
  };
  useEffect(() => {
      scrollToElementWithOffset("#form", -10);
    
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <SimpleGrid cols={3}  id="form">
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextInput label="Name" placeholder="Enter name" {...field} />
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextInput
                type="email"
                label="Email"
                placeholder="Enter email address"
                {...field}
              />
            )}
          />

          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <NumberInput
                label="Phone Number"
                placeholder="Enter phone number"
                allowNegative={false}
                allowDecimal={false}
                hideControls
                {...field}
              />
            )}
          />
        </SimpleGrid>

        <Center>
          <Button
            variant="gradient"
            type="submit"
            mt="xl"
            size="sm"
            loading={isLoading}
            loaderProps={{ type: "dots" }}
            rightSection={<img src="/images/svg/link.svg" />}
          >
            Generate Link
          </Button>
        </Center>
      </form>
    </>
  );
};

export default QuoteLinkForm;
